import { z } from 'zod';

import { PricingZod } from 'types/zod/pricing';

export const CreateOriginatorOptionsZod = z.object({
    send_email: z.boolean().optional(),
    auto_sign_relevant: z.boolean().optional(),
    sign_relevant: z.boolean().optional(),
    send_password_in_email: z.boolean().optional(),
    link_to_creator: z.boolean().optional(),
    advisor_aws_id: z.string().optional(),
    pricing: PricingZod.optional(),
});
export type CreateOriginatorOptions = z.infer<typeof CreateOriginatorOptionsZod>;
